import {makeStyles} from '@material-ui/core/styles';
import React, {useState, useEffect} from 'react';
import globalContext from '../../../config/context';
import Api from '../../../config/api';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const useHook = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian, checkedPendataan}, {setPencarian, setCheckedPendataan}] = useAppContext();

  //select Kecamatan----------------------------------------------------------------------------------------------------
  const [kecamatan, setKecamatan] = useState('');
  const [kecamatanOptions, setKecamatanOptions] = useState('');
  const handleKecamatan = (event, value) => {
    // setKecamatan(event.target.value); -- FormControl
    setKecamatan(value ? value.kd_kecamatan : '');
    setKecamatanOptions(value);
  };
  const [itemKecamatan, setItemKecamatan] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          setItemKecamatan(response.data);
        }
      }
    });
  }, []);

  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_kecamatan) === String(kecamatan)) {
              setKecamatanOptions(item);
            }
          }
        }
      }
    });
  }, [kecamatan]);

  //select Kelurahan----------------------------------------------------------------------------------------------------
  const [kelurahan, setKelurahan] = useState('');
  const [kelurahanOptions, setKelurahanOptions] = useState('');
  const handleKelurahan = (event, value) => {
    // setKelurahan(event.target.value); -- FormControl
    setKelurahan(value ? value.kd_kelurahan : '');
    setKelurahanOptions(value);
  };

  const [itemKelurahan, setItemKelurahan] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/kelurahan', {
      kec: kecamatan ? kecamatan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          setItemKelurahan(response.data);
        }
      }
    });
  }, [kecamatan]);

  useEffect(() => {
    Api.get('gis/ref/kelurahan', {
      kec: kecamatan ? kecamatan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_kelurahan) === String(kelurahan)) {
              setKelurahanOptions(item);
              onKinerjaKelurahan();
            }
          }
        }
      }
    });
  }, [kelurahan]);

  //Chart Kinerja Pendataan--------------------------------------------------------------------------------------
  useEffect(() => {
    if (checkedPendataan === true) {
      // onKinerjaKelurahan();
      onKinerjaSurveyor();
      onKinerjaTarget();
    }
  }, [checkedPendataan]);

  let kec = kecamatan ? kecamatan : pencarian.kecamatan;
  let kel = kelurahan ? kelurahan : pencarian.kelurahan;
  const [kinerjaKelurahan, setKinerjaKelurahan] = useState([]);
  const onKinerjaKelurahan = () => {
    Api.get('gis/chart/kinerja_kelurahan', {
      kec: kec,
      kel: kel,
    }).then(function (response) {
      // console.log(response.data);
      if (response) {
        if (response.data) {
          setKinerjaKelurahan(response.data);
        }
      }
    });
  };

  const [kinerjaSurveyor, setKinerjaSurveyor] = useState([]);
  const onKinerjaSurveyor = () => {
    Api.get('gis/chart/kinerja_surveyor').then(function (response) {
      // console.log(response.data);
      if (response) {
        if (response.data) {
          setKinerjaSurveyor(response.data);
        }
      }
    });
  };

  const [kinerjaTarget, setKinerjaTarget] = useState([]);
  const [kinerjaTargetTotal, setKinerjaTargetTotal] = useState({});
  const onKinerjaTarget = () => {
    Api.get('gis/chart/kinerja_target').then(function (response) {
      // console.log(response.data);
      if (response) {
        if (response.data.list && response.data.total[0]) {
          setKinerjaTarget(response.data.list);
          setKinerjaTargetTotal(response.data.total[0]);
        }
      }
    });
  };

  return [
    {
      onKinerjaKelurahan,
      kinerjaKelurahan,
      kinerjaSurveyor,
      kinerjaTarget,
      kinerjaTargetTotal,
    },
    {kecamatan, setKecamatan, kecamatanOptions, setKecamatanOptions, handleKecamatan, itemKecamatan},
    {kelurahan, setKelurahan, kelurahanOptions, setKelurahanOptions, handleKelurahan, itemKelurahan},
  ];
};

export default useHook;
